exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".finish-text[data-v-d1bcb130]{margin-top:11px;font-size:13px;font-weight:400;color:#9394a3;line-height:18px;text-align:center}.m-four-detail[data-v-d1bcb130]{margin-top:113px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d1bcb130","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/agent/pay-finish.vue
// module id = 187
// module chunks = 1 5